"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientsModule = void 0;
const router_1 = require("client/components/router");
const patients_detail_1 = require("./modules/patients-detail");
const patients_import_1 = require("./modules/patients-import");
const patients_import_map_header_1 = require("./modules/patients-import-map-header");
const patients_import_preview_1 = require("./modules/patients-import-preview");
const patients_import_select_header_1 = require("./modules/patients-import-select-header");
const patients_list_1 = require("./modules/patients-list");
class PatientsModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("import", /^\/patients\/import?$/, patients_import_1.PatientsImport);
        this.addRoute("select", /^\/patients\/import\/select?$/, patients_import_select_header_1.PatientsImportSelectHeader);
        this.addRoute("map", /^\/patients\/import\/map?$/, patients_import_map_header_1.PatientsImportMapHeader);
        this.addRoute("preview", /^\/patients\/import\/preview?$/, patients_import_preview_1.PatientsImportPreview);
        this.addRoute("list", /^\/patients\/?$/, patients_list_1.PatientsList);
        this.addRoute("detail", /^\/patients\/(\d+)\/?(\d+)?/, patients_detail_1.PatientsDetail);
    }
}
exports.PatientsModule = PatientsModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/patients.tsx
// module id = 3797
// module chunks = 0